export const PAGE_SIZE = 10;
export const AFTER_API_TIME = 1000;
export const ViewModalBorderRadius = 2;
export const getApiUrl = (base) => {
    const env = process.env.REACT_APP_ENV;
    console.log("API ENV:", env);
    if (env === "prod") {
        return `https://api.mm.constrogen.com/${base}`;
    }
    else {
        return `http://localhost:8000/${base}`;
        // return `https://7632-2405-201-e005-31bf-d16e-da1d-5b3b-21ff.ngrok-free.app/${base}`
    }
};
export const getSocketUrl = () => {
    const env = process.env.REACT_APP_ENV;
    if (env === "prod") {
        return `https://api.mm.constrogen.com`;
    }
    else {
        return `http://localhost:8000`;
    }
};
